import React from "react";
import "./Leftnavbar.css";
import { FaSearch } from "react-icons/fa";

export default function Leftnavbar({ patients, setSelectedPatient }) {
  return (
    <div className="left-nav">
      <p>
        <span>Patients </span> <FaSearch className="search-icon" />
      </p>
      {patients.map((patient) => (
        <div
          key={patient.id}
          className="patient-row"
          onClick={() => setSelectedPatient(patient)}
        >
          <div className="patient-details">
            <img
              src={patient.profile_picture}
              alt={patient.name}
              className="patients-image"
            />
            <div>
              <div className="patients-name">
                {patient.name}
                <p id="patient-age">
                  <span style={{fontSize:"13px"}}>{patient.gender}</span>
                  <span style={{fontSize:"13px"}}>{patient.age}</span>

                </p>
              </div>
            </div>
          </div>
          <div className="patient-menu">⋮</div>
        </div>
      ))}
    </div>
  );
}
